import React, { useContext, useState } from 'react';
import { ShoppingBag } from 'lucide-react';
import { CartContext } from '../CartContext';
import CartItem from './CartItem';

export default function ShoppingCartPage({ setPage }) {
  const { cart, updateQuantity, removeFromCart, totalPrice } = useContext(CartContext);
  const [deliveryAddress, setDeliveryAddress] = useState(() => {
    return localStorage.getItem('cusAddress') || '';
  });

  const [deliveryDate, setDeliveryDate] = useState(() => {
    const today = new Date();
    return today.toISOString().split('T')[0]; // "YYYY-MM-DD"
  });

  const handleProceed = () => {
    if (!deliveryAddress.trim()) {
      alert('Please enter a delivery address.');
      return;
    }

    // ✅ Store in localStorage so OrderPage can access
    localStorage.setItem('deliveryAddress', deliveryAddress);
    localStorage.setItem('deliveryDate', deliveryDate);

    setPage('order');
  };

  if (cart.length === 0) {
    return (
      <div className="text-center py-20">
        <ShoppingBag className="mx-auto h-24 w-24 text-gray-300" />
        <h2 className="mt-4 text-2xl font-semibold mb-2 text-gray-800">Your cart is empty</h2>
        <p className="text-gray-500 mb-6">Looks like you haven't added anything yet.</p>
        <button
          onClick={() => setPage('products')}
          className="bg-teal-600 text-white font-bold py-3 px-8 rounded-lg hover:bg-teal-700 transition duration-300 shadow-md hover:shadow-lg"
        >
          Start Shopping
        </button>
      </div>
    );
  }

  return (
    <div className="container mx-auto max-w-4xl">
      <h1 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-8 text-center">Your Shopping Cart</h1>
      <div className="bg-white p-4 sm:p-8 rounded-2xl shadow-xl space-y-6">
        {/* Cart Items */}
        {cart.map(item => (
          <CartItem
            key={item.id}
            item={item}
            onUpdateQuantity={updateQuantity}
            onRemove={removeFromCart}
          />
        ))}

        {/* Delivery Details */}
        <div className="mt-6 space-y-4">
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-1">Delivery Address</label>
            <textarea
              rows="3"
              value={deliveryAddress}
              onChange={(e) => setDeliveryAddress(e.target.value)}
              className="w-full p-3 border border-gray-300 rounded-lg shadow-sm focus:ring-teal-500 focus:border-teal-500 resize-none"
              placeholder="Enter your delivery address here"
              required
            />
          </div>
          {/* Delivery Date Picker */}
          <div className="mt-6">
            <label htmlFor="deliveryDate" className="block text-sm font-medium text-gray-800 mb-2">
              Delivery Date
            </label>
            <div className="relative">
              <input
                id="deliveryDate"
                type="date"
                value={deliveryDate}
                min={new Date().toISOString().split("T")[0]}
                onChange={(e) => setDeliveryDate(e.target.value)}
                className="w-full appearance-none border border-gray-300 rounded-xl px-4 py-3 text-gray-800 bg-white shadow-sm focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-teal-500 transition duration-200"
                required
              />
            </div>
          </div>

        </div>

        {/* Total & Checkout */}
        <div className="mt-8 pt-6 border-t-2 border-gray-100 flex flex-col sm:flex-row justify-between items-center gap-4">
          <h2 className="text-2xl font-bold text-gray-800">
            Total: <span className="text-teal-600">₹{totalPrice.toFixed(2)}</span>
          </h2>
          <button
            onClick={handleProceed}
            className="w-full sm:w-auto bg-teal-600 hover:bg-teal-700 text-white font-bold py-3 px-8 rounded-lg transition duration-300 shadow-md hover:shadow-lg"
          >
            Proceed to Checkout
          </button>
        </div>
      </div>
    </div>
  );
}
